/**
 * Build query params for GET /api/v1/onboarding/tutor
 */
export function buildTutorSearchParams({
  searchQuery = '',
  subject = '',
  level = '',
  priceRange = '',
  minFee = '',
  maxFee = '',
  selectedDate = '',
  selectedTime = '',
  recurring = false,
} = {}) {
  const params = new URLSearchParams();
  const q = String(searchQuery || '').trim();
  const sub = String(subject || '').trim();

  if (q) params.append('searchString', q);
  if (sub) params.append('subject', sub);
  if (level) params.append('level', level);
  params.append('priceRange', priceRange || 'lowToHigh');
  if (selectedDate) params.append('availability', selectedDate);
  // Time matching is verified against actual tutor slots in the client. The
  // staging API's time filter is unreliable, especially for midnight slots.
  if (recurring) params.append('recurring', 'true');
  if (minFee !== '' && minFee != null) params.append('minFee', String(minFee));
  if (maxFee !== '' && maxFee != null) params.append('maxFee', String(maxFee));

  return params;
}
